module.exports = __webpack_public_path__ + "img/ThreeDogs.855bbfa3.svg";